import type { CSSProperties, ReactNode } from "react";

/**
 * Badge / pílula de status (Design.md §9). Tons normativos (§3.2/§10): azul para
 * info, laranja para ação/destaque, verde só sucesso, âmbar só aviso, cinza
 * para estados neutros (Encerrado/Cancelado).
 */
export type BadgeTone = "blue" | "orange" | "green" | "amber" | "gray";

const TONE_STYLE: Record<BadgeTone, CSSProperties> = {
  blue: { background: "var(--blue-soft)", color: "var(--blue)" },
  orange: { background: "var(--orange-soft)", color: "var(--orange)" },
  green: { background: "rgba(46, 125, 82, 0.14)", color: "var(--green)" },
  amber: { background: "rgba(154, 107, 18, 0.14)", color: "var(--amber)" },
  gray: { background: "var(--panel-alt)", color: "var(--text-muted)" }
};

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  title?: string;
  style?: CSSProperties;
}

export function Badge({
  tone = "gray",
  children,
  title,
  style
}: BadgeProps): ReactNode {
  const merged: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.25rem",
    fontSize: 11,
    fontWeight: 700,
    lineHeight: 1.4,
    padding: "0.14rem 0.5rem",
    borderRadius: 20,
    whiteSpace: "nowrap",
    ...TONE_STYLE[tone],
    ...(style ?? {})
  };

  return title === undefined ? (
    <span style={merged}>{children}</span>
  ) : (
    <span style={merged} title={title}>
      {children}
    </span>
  );
}
